import {
  formatMakeupsExpiryEligiblePanelDescription,
  isMakeupsNoExpiry,
} from "./makeupExpirySettings";
import {
  formatMakeupsAnnualLimitEligiblePanelLine,
  isMakeupsNoAnnualLimit,
} from "./makeupAnnualLimitSettings";
import type { MakeupsAnnualPeriod } from "./makeupAnnualPeriod";

export function formatMakeupsEligiblePanelDescription(
  expiryDays: number,
  annualRequestLimit: number,
  annualPeriod: MakeupsAnnualPeriod,
): string {
  const expiryLine = formatMakeupsExpiryEligiblePanelDescription(expiryDays);
  const annualLine = formatMakeupsAnnualLimitEligiblePanelLine(
    annualRequestLimit,
    annualPeriod,
  );

  if (!annualLine) return expiryLine;
  return `${expiryLine} ${annualLine}`;
}

export function formatMakeupsEligibleEmptyStateMessage(
  expiryDays: number,
  annualRequestLimit: number,
  annualPeriod: MakeupsAnnualPeriod,
): string {
  const expiryPart = isMakeupsNoExpiry(expiryDays)
    ? "eligible sessions appear here without a time limit"
    : `eligible sessions appear here for ${expiryDays} day${expiryDays === 1 ? "" : "s"}`;

  const annualPart = isMakeupsNoAnnualLimit(annualRequestLimit)
    ? ""
    : ` Each student can request up to ${annualRequestLimit} makeup${annualRequestLimit === 1 ? "" : "s"} per ${annualPeriod === "seasonal" ? "seasonal year (September–August)" : "calendar year (January–December)"}.`;

  return `When a teacher marks your student absent, ${expiryPart}.${annualPart} You can also track requests after you submit them.`;
}
